import { readable, writable, derived, get } from "svelte/store";
import { topics, currentTopics } from "./data";
import { platform } from "../../components/MediaQuerySsr.svelte";

// ///////////////////////////////////////////////////////////
// interaction
// ///////////////////////////////////////////////////////////
export const hovered = writable();
export const selected = writable();

export const selectedTopicId = writable("");
export const selectedTopic = derived([selectedTopicId, topics], ([$selectedTopicId, $topics]) =>
	$topics.find((t) => t.id === $selectedTopicId)
);

export let searchTerms = writable({});

export let topicButtons = derived([selectedTopic, currentTopics], ([$selectedTopic, $currentTopics]) =>
	$selectedTopic && !$currentTopics.map((t) => t.id).includes($selectedTopic.id)
		? [$selectedTopic, ...$currentTopics]
		: $currentTopics.sort((a, b) => {
				if (a.id === $selectedTopic?.id) {
					return -1;
				} else if (b.id === $selectedTopic?.id) {
					return 1;
				} else {
					return a.id.localeCompare(b.id);
				}
		  })
);

export let showAllTopicsFilterView = writable(false);

export let showMobileFilterButtons = derived(platform, ($platform) => $platform === "mobile" || $platform === "tablet");
export let showMobileAllTopicsFilterView = derived(platform, ($platform) => $platform === "mobile");
export let showBlurryBackground = derived(platform, ($platform) => $platform === "tablet" || $platform === "desktop");

export let scrollToTopOfMap = writable();
export let scrollToBottomOfMap = writable();
